<h2 mat-dialog-title>{{ data.mode === 'add' ? 'Add employee' : 'Edit employee' }}</h2>

<mat-dialog-content class="v2-dialog">
  <mat-form-field appearance="outline" class="full">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="model.name" placeholder="Full name">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full" *ngIf="data.mode === 'add'">
    <mat-label>Email</mat-label>
    <input matInput type="email" [(ngModel)]="model.email" placeholder="name@company.no">
  </mat-form-field>
  <mat-form-field appearance="outline" class="full" *ngIf="data.mode === 'edit'">
    <mat-label>Email (identity — not editable)</mat-label>
    <input matInput [value]="data.employee?.email || ''" disabled>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Employee code</mat-label>
    <input matInput [(ngModel)]="model.employeeCode">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Group</mat-label>
    <mat-select [(ngModel)]="model.groupId">
      <mat-option [value]="null">— none —</mat-option>
      <mat-option *ngFor="let g of data.groups" [value]="g.groupId">{{ g.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full" *ngIf="data.mode === 'add'">
    <mat-label>Password (optional)</mat-label>
    <input matInput type="text" [(ngModel)]="model.password" placeholder="they still accept the privacy terms themselves before first login">
  </mat-form-field>

  <div class="v2-dialog-checks">
    <mat-checkbox [(ngModel)]="model.isAdmin">Admin</mat-checkbox>
    <mat-checkbox *ngIf="data.mode === 'edit'" [(ngModel)]="model.status">Active</mat-checkbox>
    <mat-checkbox *ngIf="data.mode === 'add'" [(ngModel)]="model.isTest">Mark as test user</mat-checkbox>
    <mat-checkbox *ngIf="data.mode === 'add'" [(ngModel)]="model.sendInvite" [disabled]="!model.email"
      matTooltip="Emails a link where the employee sets their own password">Send welcome email</mat-checkbox>
  </div>

  <div class="v2-dialog-checks" *ngIf="data.mode === 'edit'">
    <button mat-stroked-button type="button" [disabled]="resettingPassword" matTooltip="Set a new password for this employee" (click)="resetPassword()">
      <mat-icon>lock_reset</mat-icon> Reset password
    </button>
    <button mat-stroked-button type="button" [disabled]="sendingResetEmail" matTooltip="Email the employee a link to set their own password" (click)="sendResetEmail()">
      <mat-icon>mail</mat-icon> Send reset email
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="ref.close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">{{ data.mode === 'add' ? 'Add' : 'Save' }}</button>
</mat-dialog-actions>
